import USER_ROLE from 'constants/role';
import {
  checkHideCashupForReceptionist,
  checkHideDetailsForReceptionist,
  checkHideStockForReceptionist,
} from 'selectors/currentSalon.selectors';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';

// These are the simple and less complex getters,
// for user, role, permission oriented state selection

export const isEffectiveReceptionist = (state) => selectEffectiveUserRole(state) === USER_ROLE.receptionist;
export const isEffectiveManager = (state) => selectEffectiveUserRole(state) === USER_ROLE.manager;

export const selectHideCashup = (state) => isEffectiveReceptionist(state) && checkHideCashupForReceptionist(state);
export const selectHideDetails = (state) => isEffectiveReceptionist(state) && checkHideDetailsForReceptionist(state);
export const selectHideStock = (state) => isEffectiveReceptionist(state) && checkHideStockForReceptionist(state);
